import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';

const PLACEHOLDER = '/images/placeholder.team.svg';

export const Logo = ({ src, alt }): React.ReactElement => {
  const [url, setUrl] = useState(src);
  const imgRef = useRef(null);

  useEffect(() => setUrl(src || PLACEHOLDER), [src]);

  return (
    <Image
      src={url}
      alt={alt}
      ref={imgRef}
      onError={(): void => setUrl(PLACEHOLDER)}
    />
  );
};

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 58px;
  max-height: 58px;
  margin: 0 10px;
`;
